import {ThorGameAssets} from "../../ThorGameAssets";
import {ThorReelBackgroundView} from "./ThorReelBackgroundView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {Ease, Linear, TweenLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ThorReelBackgroundAreaView} from "./ThorReelBackgroundAreaView";

/**
 * Created by Jerker Nord on 2018-12-10.
 */

export class ThorReelBackgroundController {

    public static YPOS_OFFSET:number = 70;
    public static XPOS_OFFSET:number = 82;

    private _reelBackground:ThorReelBackgroundView;
    private _reelId:number;
    private _currentSpinState:string;
    private _yPos:number;
    private _currentTween:TweenLite;
    private _startSpinTween:TweenLite;
    private _symStep:number;
    private _startSpinSpeed:number;
    private _spinSpinSpeed:number;
    private _symStepCounter:number;
    public spinStopSpeed:number;

    constructor(reelId:number) {
        this._reelId = reelId;
        this._symStep = GameConfig.instance.SYMBOL_HEIGHT + GameConfig.instance.SYMBOL_BOTTOM_PADDING;
        this._symStepCounter = 0;
        this.createReelBackground();
    }

    private createReelBackground():void {
        this._reelBackground = new ThorReelBackgroundView(ResourcesGroupName.MAIN, ThorGameAssets.REEL_BACKGROUNDS[this._reelId]);
        this._reelBackground.position.x = ThorReelBackgroundController.XPOS_OFFSET + ThorGameConfig.instance.REEL_DISPLAY_POSITIONS[this._reelId][0];
        this._reelBackground.position.y = ThorReelBackgroundController.YPOS_OFFSET;
        EventHandler.dispatchEvent(new GameEvent(ThorReelBackgroundAreaView.ADD_REEL_BACKGROUND, this._reelBackground));
    }

    public animate(spinState:ReelAnimationState):void {
        switch(spinState) {
            case ReelAnimationState.START_SPIN:
                this._currentSpinState = spinState;
                this.animateStartSpin();
                break;
            case ReelAnimationState.SPIN:
                this._currentSpinState = spinState;
                this.animateSpin();
                break;
            case ReelAnimationState.STOP_SPIN:
                this._currentSpinState = spinState;
                this.animateSpin();
                break;
            default:
                break;
        }
    }

    private animateStartSpin():void {
        if(this._currentTween && this._currentTween.isActive()) {
            this._currentTween.pause();
            this._currentTween.kill();
        }
        if(this._startSpinTween && this._startSpinTween.isActive()) {
            this._startSpinTween.pause();
            this._startSpinTween.kill();
        }
        this.resetPosition();
        this._startSpinTween = TweenLite.fromTo(this, this._startSpinSpeed, 0, {
            ease : GameConfig.instance.REEL_SPIN_START_EASE,
            yPos : this._symStep,
            onComplete : () => this.checkForReelBackgroundPositionRestore()
        });
    }

    private animateSpin():void {
        this.resetPosition();
        this._currentTween = TweenLite.fromTo(this, this._spinSpinSpeed, 0, {
            ease : Linear.easeNone,
            yPos : this._symStep,
            onComplete : () => this.checkForReelBackgroundPositionRestore()
        });
    }


    public animateStopSpin(ease:Ease):void {
        this.resetPosition();
        this._currentTween = TweenLite.fromTo(this, this.spinStopSpeed, 0,{
            ease : ease,
            yPos : this._symStep,
            onComplete : () => this.checkForReelBackgroundPositionRestore()
        });
    }


    private checkForReelBackgroundPositionRestore():void {
        this._symStepCounter++;

        if(this._symStepCounter > 2) {
            this._symStepCounter = 0;
            this.animateReelBackground(ThorReelBackgroundController.YPOS_OFFSET);
        }
    }

    private resetPosition():void {
        this._yPos = 0;
    }

    set yPos(value:number) {
        if(value == this._yPos) {
            return;
        }
        this._yPos = value;
        this.animateReelBackground(ThorReelBackgroundController.YPOS_OFFSET + MathHelper.floorToDecimals(value, 2));
    }

    public animateReelBackground(position:number):void {
        this._reelBackground.position.y = (this._symStep * this._symStepCounter) + position;
    }

    set startSpinSpeed(value:number) {
        this._startSpinSpeed = value;
    }

    get yPos():number {
        return this._yPos;
    }

    set spinSpinSpeed(value:number) {
        this._spinSpinSpeed = value;
    }

    public abortNudge():void {
        if(this._currentTween.isActive()) {
            this._currentTween.time(this._currentTween.duration());
        }
    }

    public nudge(nudgeStepSpeed:number, ease:Ease, symStep:number, nudgeSteps:number, delay:number = 0) {
        if(nudgeSteps === 0) {
            return;
        }

        this.resetPosition();
        this._currentTween = TweenLite.to(this, nudgeStepSpeed, {
            ease : ease,
            yPos : symStep,
            onComplete : () => this.checkForReelBackgroundPositionRestore(),
            delay : delay
        });
    }
}